import { de } from '@/components/organism/ReleaseNotes/release-notes-content/countries/de';
import { en } from '@/components/organism/ReleaseNotes/release-notes-content/countries/en';
import { fr } from '@/components/organism/ReleaseNotes/release-notes-content/countries/fr';

import { TReleaseNote } from '../types';

export const releaseNotesData: TReleaseNote = {
  version: '1.1.1',
  content: [
    {
      type: 'markdown',
      en: en.releaseNotes,
      de: de.releaseNotes,
      fr: fr.releaseNotes,
    },
    {
      type: 'image',
      en: en.image,
      de: de.image,
      fr: fr.image,
    },
    {
      type: 'markdown',
      en: en.fixesAndImprovements,
      de: de.fixesAndImprovements,
      fr: fr.fixesAndImprovements,
    },
  ],
  new_image: 'assets/images/release-new.png',
  image: 'assets/images/release_notes_sample_{locale}.png',
  video: 'assets/images/release_notes_sample_{locale}.png',
};
